<template>
  <v-container grid-list-xl fluid>
    <confirm ref="confirm"></confirm>
    <v-snackbar :timeout="3000" bottom right :color="snackbar.color" v-model="snackbar.show">
      {{ snackbar.text }}
      <v-btn dark flat @click.native="snackbar.show = false" icon>
        <v-icon>close</v-icon>
      </v-btn>
    </v-snackbar>
    <v-dialog v-model="dialog" persistent max-width="600px">
      
           <v-form v-model="valid" ref="form">                 
      <v-card>
        <v-card-title>
          <span class="headline">{{ formTitle }}</span>
        </v-card-title>
        <v-card-text>
          
          <v-container grid-list-md>
            <v-layout wrap>
              <v-flex xs12>
                <v-text-field label="Nombre de Usuario (*)" 
                v-model="editedItem.userName" 
                :rules="[v => !!v || 'Nombre de usuario es obligatorio']" 
                required
                :readonly="this.editedIndex !== -1"></v-text-field>
              </v-flex>
               <v-flex xs12>
                 <v-text-field
                v-model="editedItem.password"
                :append-icon="show1 ? 'visibility_off' : 'visibility'"
                :append-icon-cb="() => (show1 = !show1)"
                :rules="[rules.required, rules.min]"
                :type="show1 ? 'text' : 'password'"                 
                label="Password (*)"
                v-bind:hint="hintPassword"              
                counter    
                required            
              ></v-text-field>               
              </v-flex>
              <v-flex xs12>
                <v-text-field label="Nombre Completo (*)" 
                v-model="editedItem.nameFull" 
                :rules="[v => !!v || 'Nombre completo es obligatorio']" 
                required></v-text-field>
              </v-flex>
              <v-flex xs12>
                    <v-text-field
                      label="E-Mail (*)"
                       prepend-icon="mail"
                      v-model="editedItem.email"
                      hint="EJ: ejemplo@correo.com"
                      :rules="[v => !!v || 'E-Mail es obligatorio', rules.email]"
                      required
                    ></v-text-field>
                  </v-flex>
            <v-flex xs6>
                <v-select
                  v-model="editedItem.roleName"
                   prepend-icon="person"
                  :items="checkRolesPermisosAdmin()"
                  label="Rol"
                   :rules="[v => !!v || 'Rol es obligatorio']" 
                  required
                  
                ></v-select>
              </v-flex>   
              <v-flex xs6>               
                    <v-checkbox :value="editedItem.todasLasRegiones"                                
                                label="Ver todas las regiones?"
                                v-model="editedItem.todasLasRegiones">
                    </v-checkbox>
                        
              </v-flex>   
                  
              <v-flex xs12 v-if="!editedItem.todasLasRegiones">
                <v-list-item>
                <v-list-item-content>
                  <v-list-item-title>Selección de Regiones</v-list-item-title>
                </v-list-item-content>
              </v-list-item>
               <v-list-tile v-for="(reg, index) in editedItem.regiones" :key="reg.id" >
                <v-list-tile-content>
                    <v-checkbox :value="reg.boolUsuarioRegion" 
                                :key="reg.id"
                                :label="reg.codigoRegion"
                                v-model="editedItem.regiones[index].boolUsuarioRegion">
                    </v-checkbox>
                </v-list-tile-content>
            </v-list-tile>                
              </v-flex>                           
            
            </v-layout>
          </v-container>
          <small>* Campos obligatorios</small>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
         
            <v-btn color="success" @click="save" dark :loading="loadingValidacion">
            <v-icon class="mr-1">save</v-icon>Guardar
          </v-btn>
          <v-btn color="grey" @click="close" dark :loading="loadingValidacion">
            <v-icon class="mr-1">cancel</v-icon>Cancelar
          </v-btn>
        </v-card-actions>
      </v-card>
           </v-form>
    </v-dialog>
    <v-card>
      <v-card-title>
        <span class="title">Mantenedor Ejecutivos</span>
        <v-spacer></v-spacer>
          <v-btn
                            fab
                            dark
                            small
                           color="primary"
                           style="margin:0px"
                           @click="refresh()"
                          > 
                            <v-icon dark  >refresh</v-icon>
                          </v-btn>
      </v-card-title>
    </v-card>
    <v-layout row wrap>      
       
      <v-flex xs12>
        <v-card>
          <v-toolbar card dense color="transparent">
            <v-tooltip right>
                <template v-slot:activator="{ on }">
                 
                   <v-btn
                            fab
                            dark
                            small
                             v-on="on"
                              slot="activator"
                           color="green"
                           style="margin:0px"
                           @click="crear()"
                           :loading="loadingValidacion"
                          > 
                            <v-icon dark  >add</v-icon>
                          </v-btn>
                </template>
                <span>Crear Usuario</span>
              </v-tooltip>
              
             <v-spacer />

               <v-text-field
                 v-model="search"
                append-icon="search"
                label="Buscar..."
                single-line
                hide-details
                 class="mb-2"
                 @change="refresh()"
            required
              ></v-text-field>
             <div class="text-xs-center" :style="{visibility: loadingValidacion ? 'visible' : 'hidden'}" >  
                <v-progress-circular  
                  indeterminate :size="20"
                  color="primary"  
                ></v-progress-circular>
             </div>
          </v-toolbar>
          <v-divider/>
         
          <v-card-text class="mt-0">            

            <v-data-table
               :headers="headers"
              :search="search"
              :items="detalleItems"
               :rows-per-page-items="rowsPerPageItems"
              :pagination.sync="pagination"
              :total-items="totalItems"
              :loading="loading"
              rows-per-page-text="Registros por página"
               no-results-text=""
              no-data-text=""
              class="elevation-1"        
            >
              <template v-slot:items="props">
              <!-- 
 public string Id { get; set; }
        public string UserName { get; set; }
        public string Email { get; set; }
        public string Password { get; set; }
        public string NameFull { get; set; }
        public bool Activo { get; set; }
        public bool TodasLasRegiones { get; set; } 

              -->
                <td>{{ props.item.userName }}</td>
                <td>
                    {{ props.item.email }}   
                </td>
                <td>
                    {{ props.item.nameFull }}  
                </td> 
                 <td>
                    {{ getBooleanValue(props.item) }}  
                </td> 
                         
              
                <!--<td>{{ getHumanDate(props.item.fechaEnvio) }}</td>-->
                <td>{{ getRegionValue(props.item) }}</td>                 
                <td> <!--<v-btn  small dark  @click="irOC(props.item.id)" slot="activator">
                <v-icon>zoom_in</v-icon>
                Ver Detalle
              </v-btn>-->
               <v-btn depressed outline icon fab dark color="primary" small @click="verDetalleUsuario(props.item)"  slot="activator">
                      <v-icon>edit</v-icon>
                    </v-btn>
                    <v-btn depressed outline icon fab dark :color="getActivateValue(props.item)" small @click="activate(props.item)"  slot="activator">
                      <v-icon>{{ getActivateIcon(props.item) }}</v-icon>
                    </v-btn>
              </td>
                
              </template>
              <template slot="pageText" slot-scope="props">
                Registros {{ props.pageStart }} - {{ props.pageStop }} de
                {{ props.itemsLength }}
              </template>
              <v-alert
                slot="no-results"
                :value="true"
                color="error"
                icon="warning"
              >Su busqueda "{{ search }}" no obtuvo resultados.</v-alert>
            </v-data-table>
          </v-card-text>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>
<style>
.comentariosHome {
  height: 260px;
  overflow-y: auto;
}
.comentarioStatusHome {
  height: 40px;
}
.comentarioStatusLineasHome.v-list--two-line .v-list__tile {
  height: 40px;
  margin-bottom: 3px;
}
.truncate {
  max-width:200px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
</style>
<script>
//import LicitacionesService from "@/services/LicitacionesService";

import OrdenCompraService from "@/services/OrdenCompraService";
import Loader from "@/components/Loader";
import moment from "moment";
//import FiltrosService from "@/services/FiltrosService";
import VWidget from "@/components/VWidget";
import AppEvents from "@/eventBus";
//import LicitacionesItems from "@/components/LicitacionesItems";
export default {
  components: {
    VWidget,
    Loader
  },
  data: () => ({
    snackbar: {
      show: false,
      text: "",
      color: ""
    },
    valid: false,
     dialog: false,
     show1: false,
    search: null,
    searchPendienteAceptacion: null,
    searchCancelada: null,
    loading: false,
    loadingPendiente: false,
    loadingValidacion: false,
    loadingCancelada: false,
    rules: {
      required: value => !!value || 'Password es obligatorio.',
      min: v => v.length >= 8 || 'Mínimo 8 carácteres',
      email: (value) => {
        const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        return pattern.test(value) || 'E-mail con formato incorrecto.';
      }   
    },
    editedIndex: -1,
    editedItem: {
      Id: '',
      userName: '',
      nameFull: '',
      mail: '',     
      password: '',
      editar: 1,
      activo: 1,
      todasLasRegiones: true,
      regiones: []
    },
    defaultItem: {
      userName: '',
      nameFull: '',
      mail: '',     
      password: '',
      editar: 0,
      activo: 1,
      todasLasRegiones: true,
      regiones: []
    },
    /*
        public string Id { get; set; }
        public string UserName { get; set; }
        public string Email { get; set; }
        public string Password { get; set; }
        public string NameFull { get; set; }
        public bool Activo { get; set; }
        public bool TodasLasRegiones { get; set; } 
    
    */
    detallePendiente: [],
    detallePendienteServer: [],
    detalleCanceladas: [],
    detalleCanceladasServer: [],
    detalleItems: [], 
    rowsPerPageItems: [20, 50, 100],
    pagination: {
      page: 1,
      rowsPerPage: 20,
      sortBy: "userName",
      descending: false
    },  
    totalItems: 0,      
    headers: [
      {
        text: "UserName",
        align: "left",
        sortable: true,
        value: "userName"
      },
      {
        text: "Email",
        align: "left",
        sortable: true,
        value: "email"
      },
      {
        text: "Nombre Completo",
        align: "left",
        sortable: true,
        value: "nameFull"
      },      
      {
        text: "Usuario Activo?",
        align: "left",
        sortable: true,
        value: "activo"
      } ,
       {
        text: "Regiones asignadas",
        align: "left",
        sortable: true,
        value: "todasLasRegiones"
      } 
    ]
  }),
  methods: {
     close () {
     this.dialog = false;  
      this.$refs.form.reset();       
      this.editedIndex = -1;
      this.refresh();
      
    },
    async activate(item)
    {
      let opcion = item.activo;
     
       this.$refs.confirm
        .open(
          opcion ? "Confirmar desactivación usuario" : "Confirmar reactivación usuario",
          opcion ? "Esta seguro de desactivar el usuario "+ item.userName+" ? " : "Esta seguro de reactivar el usuario "+ item.userName+" ? ",
          {
            color: "green",
            width: 500
          }
          ,
           false
        )
        .then((confirm) => {
          if (confirm) {
             item.activo = !item.activo;
            this.loadingValidacion = true;
             const response =   OrdenCompraService.activateEjecutivo(        
              item
              )
                .then(r => {
                  
                
                  this.loadingValidacion = false;
                  this.close();
                      this.snackbar = {
                        show: true,
                        timeout: 3000,
                        color: 'green',
                        text:   opcion ? "Usuario desactivado con éxito" : "Usuario reactivado con éxito"
                      };
                }).catch(r => {
                  this.loadingValidacion = false;
                    this.snackbar = {
                        show: true,
                        timeout: 10000,
                        color: 'red',
                        text:   r.response.data.mensaje
                      };
                  console.log(r.response);
                });


          }
        })
    },
    async save()
    {
      let opcion = this.editedIndex > -1;
      
       if (this.$refs.form.validate())
      {
          this.$refs.confirm
        .open(
          opcion ? "Confirmar modificación datos" : "Confirmar crear nuevo usuario",
          opcion ? "Esta seguro de guardar los datos modificados?." : "Esta seguro de crear el nuevo usuario?",
          {
            color: "green",
            width: 500
          }
          ,
           false
        )
        .then((confirm) => {
          if (confirm) {
             var valor = this.editedItem;
        this.loadingValidacion = true;
        let user = {
          id : valor.id,
          userName : valor.userName,
          email: valor.email,
          password: valor.password,
          nameFull: valor.nameFull,
          activo: valor.activo,
          todasLasRegiones: valor.todasLasRegiones === null ? false : valor.todasLasRegiones,
          regiones: valor.regiones  

        } ;
        if(opcion)
        {
          const response =   OrdenCompraService.updateEjecutivo(        
        user
        )
          .then(r => {
            debugger;
          
            this.loadingValidacion = false;
            this.close();
                this.snackbar = {
                  show: true,
                  timeout: 3000,
                  color: 'green',
                  text:   opcion ? "Usuario modificado con éxito" : "Usuario creado con éxito"
                };
          })
          .catch(r => {
             this.loadingValidacion = false;
              this.snackbar = {
                  show: true,
                  timeout: 10000,
                  color: 'red',
                  text:   r.response.data.mensaje
                };
            console.log(r.response);
          });
        }
        else
        {
          const response =   OrdenCompraService.createEjecutivo(        
        user
        )
          .then(r => {
            debugger;
          
            this.loadingValidacion = false;
            this.close();
                this.snackbar = {
                  show: true,
                  timeout: 3000,
                  color: 'green',
                  text:   opcion ? "Usuario modificado con éxito" : "Usuario creado con éxito"
                };
          })
          .catch(r => {
             this.loadingValidacion = false;
              this.snackbar = {
                  show: true,
                  timeout: 10000,
                  color: 'red',
                  text:   r.response.data.mensaje
                };
            console.log(r.response);
          });
        }
        
          return true;
              
          }
        });


        
      }
      

    },
    checkRolesPermisosAdmin ()
    {
      return ['Ejecutivo'];
    },
     getRegionValue (val)
    {
      debugger;
      if (!val.todasLasRegiones) return val.regionesUsuario;
      return (val.todasLasRegiones === true ? 'TODAS' : val.regionesUsuario) ;
       
    },
     getBooleanValue (val)
    {
     
      return (val.activo === true ? 'Sí' : 'No') ;
       
    },
    getActivateValue (val)
    {
     
      return (val.activo === true ? 'red' : 'green') ;
       
    },
     getActivateIcon (val)
    {
     
      return (val.activo === true ? 'delete' : 'check') ;
       
    },
    findPendienteAceptacion()
    {
       var busqueda = this.searchPendienteAceptacion == null ? "" : this.searchPendienteAceptacion;
      this.detallePendiente = this.detallePendienteServer.filter(item => item.codigo.toUpperCase().includes(busqueda.toUpperCase()));
    },
    findCancelada()
    {
      var busqueda = this.searchCancelada == null ? "" : this.searchCancelada;
      this.detalleCanceladas = this.detalleCanceladasServer.filter(item => item.codigo.toUpperCase().includes(busqueda.toUpperCase()));
    },
    async refresh()
    {
      const response =  await this.getAllData();
    },
    async crear()
    {
    this.loadingValidacion = true;
      const response = await OrdenCompraService.getRegionesEjecutivo('0');
      debugger;
       this.editedIndex = -1;
      
      this.editedItem = Object.assign({}, this.defaultItem);
      this.editedItem.regiones = response.data;
      this.editedItem.editar = 0;
      this.dialog = true;
      this.loadingValidacion = false;
    },
    async verDetalleUsuario(usuario)
    {
      
      this.loadingValidacion = true;
      const response = await OrdenCompraService.getRegionesEjecutivo(usuario.id);
      debugger;
       this.editedIndex =  this.detalleItems.indexOf(usuario);
      
      this.editedItem = Object.assign({}, usuario);
      this.editedItem.regiones = response.data;
      this.editedItem.editar = 1;
      this.dialog = true;
      this.loadingValidacion = false;


    },
    handleClick(item) {
      debugger;
    },
     
     calculaStatus(estado) {
      if (estado === "PENDIENTE ACEPTACION") {
        return "deep-purple darken-1";
      } else if (estado === "CANCELADA") {
        return "red";
      } else if (estado === "VALIDADA" || estado === "ACEPTADA" || estado === "RECEPCION CONFORME") {
        return "green";
      } else if (estado === "PENDIENTE VALIDACION") {
        return "blue darken-1";
      }else {
        return "grey";
      }
    },
     async getOCDashboardExcel(estado) {
      this.loadingValidacion = true;
      const response = await OrdenCompraService.getOCDashboardExcel(estado);
      this.loadingValidacion = false;
    },
    async getAllEjecutivos()
    {
      let paging = this.pagination;
      let sort = paging.sortBy === null ? "userName" : paging.sortBy;
      let direction =
        paging.descending === null
          ? " desc"
          : paging.descending === true
          ? " desc"
          : " asc";
      sort = sort + direction;
      let paginacion =
        "sort=" +
        sort +
        "&page=" +
        paging.page +
        "&pageSize=" +
        paging.rowsPerPage;

        debugger;
        this.loadingValidacion = true;
        var busqueda = (this.search == null ? '' : this.search);
      const response = await OrdenCompraService.getEjecutivosPaging(        
        paginacion ,
        busqueda 
      )
        .then(r => {
          debugger;
          this.detalleItems = r.data.data;
          this.totalItems = r.data.totalCount;
          this.loadingValidacion = false;
        })
        .catch(r => {
          console.log(r.response);
        });
        
    },     
    async getAllData()
    {
      const response = await this.getAllEjecutivos();
             
    }
  }   
  ,
  computed: {
    formTitle () {
      return this.editedIndex === -1 ? 'Nuevo Usuario' : 'Editar Usuario';
    },
    hintPassword ()
    {
      return this.editedIndex === -1 ? 'Al menos 8 carácteres' : 'Al cambiar este texto usted modificará el password del usuario y este deberá volver a conectarse';
    },
    form () {
      return {
        userName: this.editedItem.userName,
        nameFull: this.editedItem.nameFull,
        mail: this.editedItem.mail,
        roleName: this.editedItem.roleName,
        idUsuario: this.editedItem.idUsuario,
        password: this.editedItem.password,
        editar: this.editedItem.editar
      };
    }
  },
   mounted() {
     /*this.$refs.navidad
              .open("Saludo de navidad", "saludo de navidad", {
                color: "orange",
                width: 800
              })
              .then(confirm => {
                if (confirm) {
                   
                }
              });*/
              
              const response = this.getAllData();
  },
  
   watch: {
    pagination: {
      handler() {
        this.getAllData();
      },
      deep: true
    },
  }
};
</script>
